// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--2YeUy","title":"layout-module--title--3ofkA"};